import { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import BtnLoader from "../Loader/BtnLoader";
import { CreateCompliancesApi } from "../../../services/apis/Agency";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const ComplianceVerification = ({agencyId, setTabValue }) => {
  const navigate = useNavigate();
  const [inputData, setInputData] = useState({
    pan_front: null,
    gst: null,
    business_registration: null,
    agree_terms: false,
  });
  
  const [previewImages, setPreviewImages] = useState({
    pan_front: null,
    gst: null,
    business_registration: null,
  });

  // Simulating API images (Replace with actual API response)
  const [apiImages, setApiImages] = useState({
    pan_front: null,
    gst: null,
    business_registration: null,
  });

  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    // Fetch API images if needed
  }, []);

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      const file = files[0];
      setInputData({ ...inputData, [name]: file });

      // Generate preview URL
      const previewURL = URL.createObjectURL(file);
      setPreviewImages({ ...previewImages, [name]: previewURL });

      // Clear API image if a new file is uploaded
      setApiImages({ ...apiImages, [name]: null });
    }
  };


  const removeImage = (name) => {
    setInputData({ ...inputData, [name]: null });
    setPreviewImages({ ...previewImages, [name]: null });
    setApiImages({ ...apiImages, [name]: null });

    const fileInput = document.querySelector(`input[name="${name}"]`);
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const handleCheckboxChange = (e) => {
    setInputData({ ...inputData, agree_terms: e.target.checked });
  };

  const validate = () => {
    const newErrors = {};
    if (!inputData.pan_front && !apiImages.pan_front)
      newErrors.pan_front = "PAN upload is required.";
    if (!inputData.agree_terms)
      newErrors.agree_terms = "You must agree to the terms & conditions.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      try {
        const response = await CreateCompliancesApi(agencyId,inputData);
        if (response?.data?.success) {
          Swal.fire({
            icon: "success",
            title: "Agency",
            text: response?.data?.message,
          });
          toast.success(response?.data?.message, {
           position: 'top-center'
          });
          navigate("/agency-list");
        // Clear uploaded file previews
        setInputData({
          pan_front: null,
          gst: null,
          business_registration: null,
          agree_terms: false,
        });

        setPreviewImages({
          pan_front: null,
          gst: null,
          business_registration: null,
        });
        // setTabValue("Next-Tab");
      }
      } catch (error) {
        console.log("Error", error);
        toast.error(error?.response?.data?.message);
      } finally {
        setBtnLoading(false);
      }
    }
  };

  return (
    <>
      <ToastContainer />
      <form onSubmit={handleSubmit}>
        <div className="container-fluid my-0">
          <div className="profile-card card-bx">
            <h6 className="card-title">Upload Documents</h6>
            <div className=" mt-4">
              <div className="row">
              {/* PAN Upload */}
              <div className="col-md-6 mb-3">
                <label className="col-form-label">PAN Upload *</label>
                <input
                  name="pan_front"
                  type="file"
                  className="form-control"
                  onChange={handleFileChange}
                />
                {(previewImages.pan_front || apiImages.pan_front) && (
                  <div className="position-relative mt-2">
                    <img
                      src={previewImages.pan_front || apiImages.pan_front}
                      alt="PAN Preview"
                      className="img-thumbnail"
                      width="100"
                    />
                    <button
                      type="button"
                      className="btn-close position-absolute top-0 end-0"
                      onClick={() => removeImage("pan_front")}
                    />
                  </div>
                )}
                {errors.pan_front && <small className="text-danger">{errors.pan_front}</small>}
              </div>

              {/* GST Certificate */}
              <div className="col-md-6 mb-3">
                <label className="col-form-label">GST Certificate</label>
                <input
                  name="gst"
                  type="file"
                  className="form-control"
                  onChange={handleFileChange}
                />
                {(previewImages.gst || apiImages.gst) && (
                  <div className="position-relative mt-2">
                    <img
                      src={previewImages.gst || apiImages.gst}
                      alt="GST Certificate Preview"
                      className="img-thumbnail"
                      width="100"
                    />
                    <button
                      type="button"
                      className="btn-close position-absolute top-0 end-0"
                      onClick={() => removeImage("gst")}
                    />
                  </div>
                )}
              </div>

              {/* Business Registration */}
              <div className="col-md-6 mb-3">
                <label className="col-form-label">Business Registration</label>
                <input
                  name="business_registration"
                  type="file"
                  className="form-control"
                  onChange={handleFileChange}
                />
                {(previewImages.business_registration || apiImages.business_registration) && (
                  <div className="position-relative mt-2">
                    <img
                      src={previewImages.business_registration || apiImages.business_registration}
                      alt="Business Registration Preview"
                      className="img-thumbnail"
                      width="100"
                    />
                    <button
                      type="button"
                      className="btn-close position-absolute top-0 end-0"
                      onClick={() => removeImage("business_registration")}
                    />
                  </div>
                )}
              </div>
              </div>
              {/* Terms & Conditions Checkbox */}
              <div className="mb-3">
              <h6 className="card-title">Terms & Conditions Agreement</h6>
              <div>
              <label className="d-flex gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  name="agree_terms"
                  checked={inputData.agree_terms}
                  onChange={handleCheckboxChange}
                />
                  I agree to the portal terms & conditions and privacy policy
                </label>
                {errors.agree_terms && <small className="text-danger d-block">{errors.agree_terms}</small>}
              </div>
              </div>
              {/* Submit Button */}
              <div className="d-flex justify-content-end gap-4 mt-4">
              <button type="submit" className="btn btn-primary" disabled={btnLoading}>
                {btnLoading && <BtnLoader /> } Submit
              </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default ComplianceVerification;
